<script setup>
/* eslint-disable @intlify/vue-i18n/no-dynamic-keys -- demo content uses a fixed translation-key catalog. */
import { useAccount } from 'dashboard/composables/useAccount';
import EmptyStateLayout from 'dashboard/components-next/EmptyStateLayout.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import AssistantCard from 'dashboard/components-next/lumerai/assistant/AssistantCard.vue';
import FeatureSpotlight from 'dashboard/components-next/feature-spotlight/FeatureSpotlight.vue';
import { assistantsList } from 'dashboard/components-next/lumerai/pageComponents/emptyStates/lumeraiEmptyStateContent.js';

const emit = defineEmits(['click']);
const { isOnLumeratecCloud } = useAccount();

const onClick = () => {
  emit('click');
};
</script>

<template>
  <FeatureSpotlight
    :title="$t('LUMERAI.ASSISTANTS.EMPTY_STATE.FEATURE_SPOTLIGHT.TITLE')"
    :note="$t('LUMERAI.ASSISTANTS.EMPTY_STATE.FEATURE_SPOTLIGHT.NOTE')"
    fallback-thumbnail="/assets/images/dashboard/lumerai/assistant-light.svg"
    fallback-thumbnail-dark="/assets/images/dashboard/lumerai/assistant-dark.svg"
    learn-more-url="https://lumeratec.com/ajuda/lumerai-assistant"
    class="mb-8"
    :hide-actions="!isOnLumeratecCloud"
  />
  <EmptyStateLayout
    :title="$t('LUMERAI.ASSISTANTS.EMPTY_STATE.TITLE')"
    :subtitle="$t('LUMERAI.ASSISTANTS.EMPTY_STATE.SUBTITLE')"
    :action-perms="['administrator']"
  >
    <template #empty-state-item>
      <div class="grid grid-cols-1 gap-4 p-px overflow-hidden">
        <AssistantCard
          v-for="(assistant, index) in assistantsList.slice(0, 5)"
          :id="assistant.id"
          :key="`assistant-${index}`"
          :name="$t(assistant.nameKey)"
          :description="$t(assistant.descriptionKey)"
          :updated-at="assistant.created_at"
        />
      </div>
    </template>
    <template #actions>
      <Button
        :label="$t('LUMERAI.ASSISTANTS.ADD_NEW')"
        icon="i-lucide-plus"
        @click="onClick"
      />
    </template>
  </EmptyStateLayout>
</template>
